"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryStartRoundDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const types_1 = require("@framework/types");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const inputs_1 = require("../../../../../../inputs");
const validation_1 = require("./validation");
const LotteryStartRoundDialog = (props) => {
    const { initialValues, ...rest } = props;
    const { ticket, price, address, maxTicket, contractId } = initialValues;
    const fixedValues = {
        contractId,
        ticket,
        price,
        address,
        maxTicket,
    };
    const handleContractChange = (form) => (_event, option) => {
        form.setValue("contractId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("address", option?.address ?? "0x");
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { disabled: false, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: "dialogs.lotteryRoundStart", testId: "LotteryRoundStartForm", ...rest, children: [(0, jsx_runtime_1.jsx)(inputs_1.CommonContractInput, { name: "contractId", data: {
                    contractModule: [types_1.ModuleType.LOTTERY],
                    contractFeatures: [types_1.ContractFeatures.RANDOM],
                }, onChange: handleContractChange, autoselect: true }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12, sm: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "ticket", tokenType: {
                                disabledOptions: [types_1.TokenType.NATIVE, types_1.TokenType.ERC20, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
                            }, contract: {
                                data: {
                                    contractModule: [types_1.ModuleType.LOTTERY],
                                    contractStatus: [types_1.ContractStatus.ACTIVE],
                                },
                            } }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 12, sm: 6 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, prefix: "price", tokenType: {
                                disabledOptions: [types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
                            }, contract: {
                                data: {
                                    contractModule: [types_1.ModuleType.HIERARCHY],
                                    contractStatus: [types_1.ContractStatus.ACTIVE],
                                },
                            } }) })] }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "maxTicket", inputProps: { min: 0 } })] }));
};
exports.LotteryStartRoundDialog = LotteryStartRoundDialog;
//# sourceMappingURL=index.js.map